var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back_icon_div",on:{"click":function($event){return _vm.goBack()}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',[_c('img',{attrs:{"src":require("@/common/assets/images/backIcon.png"),"alt":"back_icon"}})])
}]

export { render, staticRenderFns }